



















































module.exports =
  name: 'hm_footer'
  components: `{
    bottom_menu: () => import(/* webpackChunkName: "bottom_menu" */'components/inside/bottom_menu.vue'),
  }`
  data: ->
    performance: ''
    last_deploy_time: hm_date.distanceInWordsToNow(HM.last_deploy_time)
  methods:
    measurePerformance: ->
      start = performance.now()
      fib = (num) ->
        result = 0
        if num < 2
          result = num
        else
          result = fib(num-1) + fib(num-2)
      fib(35)
      @performance = "#{Math.round (performance.now() - start)}ms"
